import { AuthCalculationRule, AuthDomainContext } from '../auth.domain';

export class ValidateAuthenticationRule implements AuthCalculationRule {
	/**
	 * Valida si el cliente está logueado
	 */
	public calculate(context: AuthDomainContext): AuthDomainContext {
		const isLoggedIn = !!context.authentication;

		return {
			...context,
			isLoggedIn: isLoggedIn,
		};
	}
}
